import { useMutation } from '@apollo/client';
import { useLogin, useAccount } from '@bnnvara/accounts';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useBrand } from '@bnnvara/brand';
import { useRouter } from 'next/router';
import { PublicationViewedMutation } from '../../api/mutations/publicationViewed.gql';
import { useFingerprint } from '../../hooks/fingerprint';
import { utmParams } from '../../helpers/utmParams';
import { stripQueryParams } from '../../helpers/stripQueryParams';

/**
 * This component is responsible for sending views to the backend.
 * You can import this component on a page, and the view will be registered.
 * The mutation is sent with or without a UID. The fingerprint is always provided.
 */

const PublicationViewed = ({ id, contentType }) => {
  const { id: brandId } = useBrand();
  const { asPath } = useRouter();
  const fingerprint = useFingerprint();
  const {
    profile: { UID },
  } = useAccount();

  const [publicationViewedMutation, { loading, called }] = useMutation(
    PublicationViewedMutation
  );

  const utm = utmParams();
  const { status } = useLogin();

  const sendMutation = !loading && !called && status === 'idle';

  useEffect(() => {
    if (sendMutation) {
      publicationViewedMutation({
        variables: {
          contentId: id,
          userId: UID || null,
          brandId,
          slug: stripQueryParams(asPath),
          contentType,
          fingerprint,
          utm,
        },
      });
    }
  }, [
    publicationViewedMutation,
    id,
    sendMutation,
    contentType,
    fingerprint,
    UID,
    brandId,
    asPath,
    utm,
  ]);

  return null;
};

PublicationViewed.propTypes = {
  id: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
};

export default PublicationViewed;
